import React from 'react'
import PropTypes from 'prop-types'

function QuestionDoneMarker({questionId, checked, handleChange}) {
  const getModifier = () => {
    let modifier = ''
    if (checked) {
      modifier = 'questiondonemarker--active'
    }
    return modifier
  }

  return (
    <form className={`questiondonemarker ${getModifier()}`}>
      <label htmlFor={questionId}>
        <div className="checkbox__indicator" />
        <input checked={checked} onChange={handleChange} id={questionId} type="checkbox" name={questionId} />
        Frage abgeschlossen
      </label>
    </form>
  )
}

QuestionDoneMarker.propTypes = {
  questionId: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
}

export default QuestionDoneMarker
